let resolver = (pagePath) => (
    resolve => require(['@/views/' + pagePath], resolve)
)

export class Rt {
    constructor(name, path, page,title, children,redirect,props) {
        this.name = name;
        this.path = path;
        this.component = resolver(page);
        this.children = children;
        this.redirect = redirect;
        if(title){
            this.meta = {title}
        }
        this.props = props
        if (props) {
            Object.assign(this.meta, props);
        }
    }
    static build(name, path, page, title){
        return new Rt(name, path, page,title,undefined,undefined)
    }
    static page(path,page,title,name){
        return new Rt(name, path, page,title,undefined,undefined)
    }
    static redirect (path, redirect){
        return new Rt(undefined, path, undefined,undefined,undefined,undefined)
    }
    addChildren(){
        if(!this.children){
            this.children = []
        }
        this.children.push(...arguments)
        return this;
    }
    setProps(props){
        Object.assign(this.meta, props);
        return this;
    }
}



// WEBPACK FOOTER //
// ./src/router/routeHelp.js